"use client";

import { useRef, useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import Image, { type StaticImageData } from "next/image";
import arrowLeft from "../../lib/carousel/arrow_left.png";
import arrowRight from "../../lib/carousel/arrow_right.png";
const styles = new Proxy({"Wrapper":"Wrapper-2d708","Grid":"Grid-2d708","CarouselWrap":"CarouselWrap-2d708","Card":"Card-2d708","IconCircle":"IconCircle-2d708","Title":"Title-2d708","List":"List-2d708","ListWrapper":"ListWrapper-2d708","SlideOuter":"SlideOuter-2d708","Controls":"Controls-2d708","Dots":"Dots-2d708","Dot":"Dot-2d708","DotActive":"DotActive-2d708","ArrowBtn":"ArrowBtn-2d708"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./IconCardBulletpointsSlider.scss";*/

interface CarouselCard {
  title: string;
  image: StaticImageData | { url: string };
  bulletpointHeading?: string;
  bulletpoints: { text: string }[];
}

export default function IconCardBulletpointsCarousel({ cards }: { cards: CarouselCard[] }) {
  const sliderRef = useRef<Slider>(null);
  const [active, setActive] = useState(false);
  const [slidesToShow, setSlidesToShow] = useState(2);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const check = () => {
      const w = window.innerWidth;
      setActive(w < 1200);
      setSlidesToShow(w < 768 ? 1 : 2);
    };
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (!active) return null;

  const dotCount = cards.length;

  const SETTINGS: Settings = {
    dots: false,
    arrows: false,
    slidesToShow,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    speed: 300,
    cssEase: "ease",
    afterChange: (index) => setCurrent(index),
  };

  return (
    <div className={styles.CarouselWrap}>
      <Slider ref={sliderRef} {...SETTINGS} className="IconCardBulletpointsSlider">
        {cards.map((card, idx) => (
          <div key={idx} className={styles.SlideOuter}>
            <div className={styles.Card}>
              <div className={styles.IconCircle}>
                <Image
                  src={"url" in card.image ? card.image.url : card.image}
                  width={132}
                  height={124}
                  alt={card.title}
                />
              </div>
              <h4 className={styles.Title}>{card.title}</h4>
              <div className={styles.ListWrapper}>
                <ul className={styles.List}>
                  {card.bulletpoints.map((bp, i) => (
                    <li key={i}>{bp.text}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </Slider>
      <div className={styles.Controls}>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickPrev()}
          aria-label="Previous"
        >
          <Image src={arrowLeft} alt="Previous" width={20} height={29} />
        </button>
        <ul className={styles.Dots}>
          {Array.from({ length: dotCount }).map((_, i) => (
            <li
              key={i}
              className={i === current % dotCount ? styles.DotActive : styles.Dot}
              onClick={() => sliderRef.current?.slickGoTo(i)}
            />
          ))}
        </ul>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickNext()}
          aria-label="Next"
        >
          <Image src={arrowRight} alt="Next" width={20} height={29} />
        </button>
      </div>
    </div>
  );
}
